import React, { FC, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserIcon from "../../static/svg/UserIcon";
import DetailsIcon from "../../static/svg/DetailsIcon";
import MainLayout from "../../Layouts/MainLayout";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import AgentsCrewsIcon from "../../static/svg/AgentsCrewsIcon";
import FrequencyCrewIcon from "../../static/svg/FrequencyCrewIcon";
import FlowsCrewIcon from "../../static/svg/FlowsCrewIcon";
import LogsIcon from "../../static/svg/LogsIcon";
import { usePhase } from "../../../context/PhaseContext";
import { service } from "../../../services/AxiosServices";
import { toast } from "react-toastify";
import ConfirmDialog from "./ConfirmDialog";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
import AccessControl from "../molecules/AccessControl";
import Spinner from "./Spinner";
import AccessDenied from "./AccessDenied";

const BuildScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { getPhase, fetchPhase } = usePhase();
  const currentPhase = getPhase(Number(id));
  const crewBuild = location.pathname.includes("/crew-build");
  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [showRevertDialog, setShowRevertDialog] = useState(false);
  const accessCheckLoading = useAccessCheckLoading();


  useEffect(() => {
    if (id) {
      fetchPhase(Number(id), "crew");
    }
  }, [id]);

  const handleClick = (path: string, state?: any) => {
    navigate(path, { state });
  };

  const tiles = [
    { name: "Agents", path: `/agents/${id}`, icon: AgentsCrewsIcon },
    { name: "Frequency", path: `/frequency/${id}`, icon: FrequencyCrewIcon },
    { name: "Flows", path: `/flows/${id}`, icon: FlowsCrewIcon },
    { name: "Logs", path: `/logs/${id}`, icon: LogsIcon },
  ];

  const content = (
    <div className="All-cards p-3">
      {tiles.map((tile, index) => (
        <div
          key={index}
          onClick={() => handleClick(tile.path)}
          style={{ cursor: "pointer" }}
        >
          <div className="assigned_tiles_inner activate">
            {typeof tile.icon === "string" ? (
              <img src={tile.icon} alt={tile.name} />
            ) : (
              <tile.icon />
            )}
            <div className="tile mt-3">{tile.name}</div>
          </div>
        </div>
      ))}
    </div>
  );



  const handleComplete = async () => {
    setShowCompleteDialog(true);
  };
  
  
  
  const confirmComplete = async () => {
    if(currentPhase === 2){
      try {
        const formData = {
          entity_id: id,
          entity_type: "crew",
          phase: currentPhase,
          user_id: localStorage.getItem("user"),
        };
        await service<any>(`api/update-phase`, "post", formData);
        fetchPhase(Number(id), "crew");
        toast.success("Build phase is completed!", { autoClose: 2000 });
      } catch (err) {
        console.log(err);
      }
    }
    else {
       toast.warning('Please complete previous phase!',{autoClose:2000})
    }
    
  };
  const handleRevert = async () => {
    setShowRevertDialog(true);
  };
   const confirmRevert = async() => {
      
      try {
        const formData = {
          entity_id: id,
          entity_type: 'crew',
          phase: 2,
          revert: true,
          user_id: localStorage.getItem('user')
        };
        await service<any>(`api/update-phase`, 'post', formData);
        fetchPhase(Number(id), 'crew');
        toast.success(`Build phase is reverted successfully`, { autoClose: 2000 });
      } catch(err) {
        console.log(err);
        toast.error("Failed to revert phase", { autoClose: 2000 });
      }
    };
  
  return (
    <>
      <MainLayout>

      <AccessControl
        requiredPermissions={[
          {
            permission: "build",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
      
        <SectionHeader
          phase={currentPhase}
          revert={handleRevert}
          complete={handleComplete}
          back={true}
          title={"Crew: Build"}
          crewBuild={crewBuild}
        ></SectionHeader>

     <ConfirmDialog
        show={showCompleteDialog}
        onHide={() => setShowCompleteDialog(false)}
        onConfirm={confirmComplete}
        title="Confirm complete"
        body="Are you sure you want to complete this phase?"
        confirmText="Complete"
      />

      {/* Confirm Revert Dialog */}
      <ConfirmDialog
        show={showRevertDialog}
        onHide={() => setShowRevertDialog(false)}
        onConfirm={confirmRevert}
        title="Confirm revert"
        body="Are you sure you want to revert this phase?"
        confirmText="Revert"
      />
        <WindowHeightComponent className={""}>{content}</WindowHeightComponent>
        </AccessControl>
      </MainLayout>
    </>
  );
};
export default BuildScreen;
